import AppLayout from "@amzn/meridian/app-layout";
import { useEffect } from "react";
import ErrorBoundary from "src/components/shared/errorBoundary/errorBoundary";
import Header from "src/components/shared/header/header";
import ChatSideMenu from "src/components/shared/sideMenu/sideMenu";
import SiteToaster from "src/components/shared/siteToaster/siteToaster";
import { useAppDispatch, useAppSelector } from "src/store/store";
import { getUser } from "src/store/userSlice";
import { initAwsRum } from "src/utils/awsRUM";
import { v4 as uuidv4 } from "uuid";
import "./App.scss";
import { setConversationId } from "./pages/home/store/chatSlice";
import Routes from "./routes/routes";

const App = () => {
  const dispatch = useAppDispatch();
  const { firstName, alias, isAuthorized, token } = useAppSelector(
    (state) => state.user,
  );

  useEffect(() => {
    dispatch(setConversationId(uuidv4()));

    if (!token) {
      dispatch(getUser());
    }
  }, [dispatch, token]);

  useEffect(() => {
    if (alias) {
      initAwsRum(alias);
    }
  }, [alias]);

  return (
    <ErrorBoundary>
      <AppLayout headerComponent={Header} sidebarComponent={ChatSideMenu}>
        <SiteToaster />
        <ChatSideMenu />
        <Routes />
      </AppLayout>
    </ErrorBoundary>
  );
};

export default App;
